import { render, staticRenderFns } from "./globalKanban.vue?vue&type=template&id=2a852042&scoped=true&"
import script from "./globalKanban.vue?vue&type=script&lang=js&"
export * from "./globalKanban.vue?vue&type=script&lang=js&"
import style0 from "./globalKanban.vue?vue&type=style&index=0&id=2a852042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a852042",
  null
  
)

export default component.exports